<template>
  <div class="detail_container">
    <pc-navbar/>
    <div class="container_main">
      <!-- 头部 -->
      <div class="main_header" :style="imgStyle">
        <div class="header_center">
          <div class="center_left">
<!--            <div class="left_time"><p  v-if="data.time">申请截止时间：{{data.time}}</p></div>-->
            <div class="left_name"><p>{{jobDetail.company_name }}</p></div>
            <div class="left_address">

              <template v-if="companyDetail.industry_name">
                <span class="iconfont iconbriefcase"></span>
                <span class="infos">{{companyDetail.industry_name}}</span>
              </template>

              <span class="iconfont iconxiazai19"></span>
              <span class="infos">
                <template v-if="jobDetail.city_names && jobDetail.city_names.length">
                  <span v-for="(item ,index) in jobDetail.city_names" :key='index'>{{item+" "}}</span>
                </template>
                <span v-else>全国</span>
              </span>
            </div>
          </div>
          <div class="center_right">
            <div class="right_collection" @click="changeLike(jobDetail.token, jobDetail.company_token, jobDetail.job_is_liked)">
              <div v-if="!jobDetail.job_is_liked">+ 关注</div>
              <div v-else>已关注</div>
            </div>
            <a class="right_apply" :href="jobDetail.url" target="_blank">
              <p>网申投递</p>
            </a>
          </div>
        </div>
      </div>

      <div class="main_center">
        <!-- 中心图片 -->
        <div class="left-container">
          <div class="campus-container" v-if="campRecruitList && campRecruitList.length">
            <span class="title">校招日程</span>
            <div class="campus-list">
              <campus-container :campusList="campRecruitList" />
            </div>
          </div>

          <div class="campus-container" v-if="jobDetail.desc">
          <span class="title">校招详情</span>
          </div>
          <div class="center_left" v-html="jobDetail.desc"></div>
        </div>


        <!-- 右边信息部分 -->
        <div class="center_right">
          <div class="internal_recommend" style="cursor: pointer;">

            <div v-if="jobDetail.internal_recommend_avatar_url" style="position: relative;">
              <div class="recommend_card" @mouseover="popoverApp" @mouseout="hiddenPopoverApp">
                <div class="recommend_title">
                  职位内推
                  <div class="button" @click="showDownloadApp=true;  hasScroll(false)">获取内推</div>
                </div>
                <div class="recommend_info">
                  <div class="company-logos">
                    <template v-for="(item,index) in jobDetail.internal_recommend_avatar_url">
                      <img :src="item" :key="index+'-'+item" alt=""  v-if="index<3" >
                    </template>
                  </div>
                  <div class="introduction-text">{{jobDetail.internal_recommend_count > 3 ? jobDetail.internal_recommend_count: 3}}名用户可以帮你内推</div>
                </div>
              </div>
            </div>

            <div class="code" style="cursor: default">
              <img style="position: relative; left: 1px" src="https://files.wondercv.com/wechat-app1.png">
              <div class="title">
                <div> 打开APP即可获得内推 </div>
                <div> 该企业有<span style="">{{this.internal_recommend_count}}</span>名用户可帮你内推 </div>
              </div>
              <div class="sanjiao"></div>
            </div>
          </div>

          <a class="plugin" href="/plugin" target="_blank">
            <div class="plugin-title f_16 color_40 font_w_b">超级简历插件助手</div>
            <div class="plugin-desc f_14 color_9c">名企校招，一键网申，让你始终快人一步</div>
            <img src="https://files.wondercv.com/PC/jobdetail/plugin-icon.png" alt="" srcset="">
            <div class="plugin-desc f_14 color_9c">立即点击，了解更多</div>
          </a>

          <div class="right_title">公司信息</div>
          <div class="right_info" v-if="companyDetail.token" @click="goToCompany">
            <div class="info_title">
              <div class="info_img"><img :src="companyDetail.logo" alt=""></div>
              <div class="indo_name">{{companyDetail.company_nick_name || companyDetail.company_short_name || companyDetail.company_full_name}}</div>
            </div>
            <div class="info_" v-if="companyDetail.industry_name"><i class="iconfont iconbriefcase"></i><p>{{companyDetail.industry_name}}</p></div>
            <div class="info_" v-if="companyDetail.company_type"><i class="iconfont icongrid"></i><p>{{companyDetail.company_type}}</p></div>
            <div class="info_" v-if="companyDetail.size_min"><i class="iconfont iconusers"></i> <p>{{getCompanyScale(companyDetail.size_min, companyDetail.size_max)}}</p></div>
            <!-- <div class="info_detail" v-if="companyDetail.description">{{companyDetail.description}}</div> -->
            <div :class="showAllCompanyDescription ? 'info_detail_log' : 'info_detail'" v-if="companyDetail.description">{{companyDetail.description}}</div>
            <div class="control_des" @click="controlCompanyDes" v-if="companyDetail.description && companyDetail.description.length > 100">
              <div>{{showAllCompanyDescription ? "收起" : "展开"}}</div>
              <i class="iconfont iconchevron-up" style="" v-if="showAllCompanyDescription"></i>
              <i class="iconfont iconchevron-down" style="" v-else></i>
            </div>
          </div>

          <div class="right_info" v-else>
            <div class="info_title">
              <div class="info_img"><img :src="jobDetail.company_logo_hr || jobDetail.company_logo" alt=""></div>
              <div class="indo_name">{{jobDetail.company_name || jobDetail.company_nick_name}}</div>
            </div>
          </div>

          <div class="right_hotjob" v-if="hotJobs">
            <div class="hot_title">热门网申</div>
            <div class="hot_job">
              <div class="job_item" v-for="(item,index) in hotJobs" :key='index' @click="toCampusDetail(item)">
                <div class="img"><img :src="item.logo ? item.logo : 'https://files.wondercv.com/pc/default-company-logo.png'" style="height: 40px; width: 40px" /></div>
                <div>
                  <div class="item_name">{{item.comp_name || item.company_full_name}}</div>
                  <div class="item_time">{{recruitmentTime(item)}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="download-app" v-if="showDownloadApp" @click="showDownloadApp=false; hasScroll(true)">
      <div class="content" @click.stop>
        <div class="title">打开 APP</div>
        <div class="text">即可获取大厂专属内推码</div>
        <img src="https://files.wondercv.com/pc/code/nuxt_login_navbar.png" alt="">
      </div>
    </div>

    <!-- 公众号弹窗 -->
    <WxPublic :alertData="wxPublicAlertData" :use-state-show="false" @close="close" />

    <pc-footer/>
    <div class="layer-box" v-show="isShowLayer" @click.stop="isShowLayer = false">
      <div class="content-box">
        <div class="content-box-title">网申提醒</div>
        <div class="content-box-subtitle">关注成功，扫码可及时收到网申提醒哦～</div>
        <img class="content-image" :src="codeUrl"></img>
      </div>
    </div>
  </div>
</template>

<script>
import PcNavbar from '@/components/base/navbar';
import PcFooter from '@/components/base/pcFooter';
import api from '@/api';
import {routerTo, get_tUser, recruitmentTime} from '@/assets/js/util'
import CampusContainer from './components/campusContainer'
import {getCompanyScale} from '@/assets/js/util';
import WxPublic from '@/components/alert/wxPublic';
import Phone from '@/components/base/phone';
import moment from 'moment'
export default {
  components: {
    PcNavbar,
    PcFooter,
    CampusContainer,
    WxPublic,
    Phone,
  },
  data () {
    return {
      imgStyle: {
        backgroundImage:`url(${require('@/assets/image/jobs_background.png')})`
      },
      token:this.$route.params,
      jobDetail:{},
      campRecruitList: [],
      showDownloadApp: false,
      companyDetail: {},
      hotJobs:[],
      wxPublicAlertData: {
        show: false,
      },
      wxPublicTimeoutName: "",
      isAppDownAlbert: false,
      showAllCompanyDescription: false,
      internal_recommend_count: 3,
      moment,
      isShowLayer: false,
      codeUrl: ""
    }
  },
  created(){
    this.getCampusOfferDetail()
    //this.changeLike()
    // 获取热门校招职位
    this.getRecruitHotJobs();
    this.getCodeUrl()
  },
  beforeDestroy(){
    this.wxPublicTimeoutName && clearInterval(this.wxPublicTimeoutName);
    hasScroll(true)
  },
  methods: {
    recruitmentTime,
    // 获取校招详情
    async getCampusOfferDetail() {
      let token = this.$route.params.token
      try {
        let res = await api.campusOffers.getCampusOfferDetail(token)
        if (res.code === 1000) {
          this.jobDetail = res.data;
          this.campRecruitList = res.data.comp_recruit_schedule
          // console.log(this.campRecruitList,"==============>campRecruitList")
          // 获取公司信息
          this.getCompanyDetail(res.data.company_token);

          if (this.jobDetail.internal_recommend_avatar_url.length === 0) {
            // 添加默认头像
            [1, 2, 3].forEach(item => this.jobDetail.internal_recommend_avatar_url.push(`https://files.wondercv.com/pc/recommend_default_avatar${item}.png`));
          }

          this.internal_recommend_count = this.jobDetail.internal_recommend_count > 3 ? this.jobDetail.internal_recommend_count : 3;

        } else {
          this.$message.error(res.message)
        }
      } catch(e) {
        console.log(e)
      }
    },
    // 获取公司信息
    getCompanyDetail(company_token){
      if(!company_token){
        return
      }
      api.staticApi.getCompanyDetail(company_token).then(res=>{
        if(res.code === 1000){
          this.companyDetail = res.data;
        }
      })
    },
    //切换喜欢状态
    async changeLike(token, company_token, type) {
      if (!type) {
        // 关注
        try {
          await api.company.favoriteCompany({company_token: company_token, comp_recruit_token: token});
        } catch (err) {
          return Promise.reject(err);
        }
      } else {
        // 取消关注
        try {
          await api.company.unFavoriteCompany(company_token);
        } catch (err) {
          return Promise.reject(err);
        }
      }

      this.jobDetail.job_is_liked = !type;
      if (type) {
        this.$message.success('取消关注成功');
      } else {
        try {
          const isFocusWxPublic = await api.account.getUserCvPublic(get_tUser()["c_t"]).then(res => res.data.subscribe);
          if(isFocusWxPublic){
            let res = await api.jobs.getNetApplication()
            if (res.code === 1000) {
              if(res.data.wechat_self_net_application_status){
                this.$message.success('关注成功')
              }else {
                this.isShowLayer = true
              }
            }

          }else {
            this.wxPublicAlertData.show = true;
            this.checkFocusWxPublic();
          }
        } catch(err) {
          return Promise.reject(err);
        }
      }

      //api.jobs.updateLikeRecruit(token, {
      //  type: type ? 'dislike' : 'like',
      //}).then (async (res) => {
      //  // console.log(res,this.collection)
      //  if(res.code === 1000) {
      //      this.jobDetail.job_is_liked = !type
      //      if (type) {
      //        this.$message.success('取消关注成功');
      //      } else {
      //        try {
      //          const isFocusWxPublic = await api.account.getUserCvPublic(get_tUser()["c_t"]).then(res => res.data.subscribe);
      //          isFocusWxPublic ? this.$message.success('已关注，将为你推送最新校招信息'): (this.wxPublicAlertData.show = true, this.checkFocusWxPublic());
      //        } catch(err) {
      //          return Promise.reject(err);
      //        }
      //      }
      //  }
      //})
    },
    checkFocusWxPublic() {
      this.wxPublicTimeoutName = setInterval(async () => {
        // 验证是否扫描二维码
        try {
          const isFocusWxPublic = await api.account.getUserCvPublic(get_tUser()["c_t"]).then(res => res.data.subscribe);
          isFocusWxPublic && this.close();
        } catch(err) {
          return Promise.reject(err);
        }
      }, 3000);
    },
    close() {
      this.wxPublicTimeoutName && clearInterval(this.wxPublicTimeoutName);
      this.wxPublicAlertData.show = false;
    },
     // 公司详情
    goToCompany(){
      routerTo(`/company/${this.jobDetail.company_token}.html`,'_blank')
    },
    toCampusDetail (item) {
      routerTo(`/comp_recruit_infos/${ item.token }`, '_blank')
    },
    hasScroll(show){
      if (show) {
        document.body.style.position = 'initial'
        document.body.style.overflow = 'initial'
      }else{
        document.body.style.position = 'static'
        document.body.style.overflow = 'hidden'
      }
    },
    // 获取热门校招职位
    getRecruitHotJobs(){
      api.jobs.getRecruitHotJobs().then(res=>{
        console.log(res,'===============>>>');
        if(res.code === 1000){
          this.hotJobs = res.data.data || [];
        }
      })
    },
    getCompanyScale,
    popoverApp() {
      this.isAppDownAlbert = true;
    },
    hiddenPopoverApp() {
      this.isAppDownAlbert = false;
    },
    controlCompanyDes(event) {
      this.showAllCompanyDescription = !this.showAllCompanyDescription;
      event.stopPropagation();
    },
    getCodeUrl(){
      api.jobs.getSchoolJobsCode().then(res=>{
        if(res.code === 1000){
          this.codeUrl = res.data.image
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
 .detail_container {
   margin-top: 56px;
   width: 100%;
   //height: 1400px;
   background-color: #fff;
   font-family: PingFangSC-Regular,PingFang SC;
   .container_main {
     width: 100%;
     height: 100%;
     .main_header {
       width: 100%;
       height: 162px;
       .header_center {
         display: flex;
         justify-content: space-between;
         margin: 0 auto;
         width: 1186px;
         height: 100%;
         .center_left {
           display: flex;
           flex-direction: column;
           width: 310px;
           height: 100%;
           //margin-top: 20px;

           .left_time {
             margin-top: 26px;
             width: 230px;
             height: 14px;
             p {
               font-size:14px;
               font-weight:400;
               color:rgba(236,236,236,1);
             }
           }
           .left_name {
             margin-top: 52px;
             width: 450px;
             height: 26px;
             p {
               font-size:26px;
               font-weight:500;
               color:rgba(255,255,255,1);
             }
           }
           .left_address {
             margin-top: 20px;
             width: 500px;
             height: 14px;
             color: #fff;
             font-size: 14px;
             .infos{
               margin: 0 16px 0 4px;
               position: relative;
               top: -1px
             }
           }
         }
         .center_right {
           display: flex;
           justify-content: space-between;
           align-items: center;
           width: 280px;
           height: 100%;
           .right_collection {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100px;
              height: 48px;
              border-radius: 4px;
              border-radius:4px;
              border:1px solid rgba(255,255,255,.5);
              cursor: pointer;
              i {
              color: #FBFCFD;
              }
              div {
                font-size: 16px;
                font-weight:400;
                color: #FBFCFD;
              }
              &:hover{
                opacity: .8;
              }
           }
           .right_apply {
             display: flex;
             align-items: center;
             justify-content: center;
             width: 168px;
             height: 48px;
             border-radius: 4px;
             background-color: #FF6B4A;
             cursor: pointer;
             &:hover{
               background-color: #FF8569;
             }
             p {
               font-size:16px;
               font-weight:400;
               color:rgba(251,252,253,1);
             }
           }
         }
       }
     }

     .main_center {
       width: 1200px;
       margin: 26px auto 0;
       overflow: hidden;
       padding-bottom: 40px;
       padding-top: 30px;
       .left-container {
         width: 823px;
         float: left;
         .campus-container {
           .title {
             font-size: 18px;
             font-weight: bold;
             color: #404040;
           }
           .campus-list {
             margin-top: 29px;
           }
         }
         .center_left{
           /deep/ *{width:100%}
           font-weight:400;
           color:rgba(96,96,96,1);
           line-height: 32px;
           /deep/ img {width:100%;height: auto !important}

         }
       }
       .center_right {
          float: right;
          width: 300px;
          // height: 1126px;
          cursor: pointer;
          .right_title, .recommend_title {
            font-size:18px;
            font-weight:bold;
            color:#404040;
            line-height:25px;
          }
          .recommend_card {
            background: #F9F9F9;
            padding: 20px 16px;
            margin-bottom: 48px;
            border-radius: 6px;
          }
          .recommend_title{
            line-height: 28px;
            .button{
              width: 80px;
              height: 28px;
              background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
              border-radius: 14px;
              text-align: center;
              color: #fff;
              font-size: 14px;
              font-weight: inherit;
              float: right;
              &:hover{
                opacity: 0.8;
              }
            }
          }
          .recommend_info{
            // background: #F9F9F9;
            border-radius: 6px;
            padding: 16px 0px 0px 0px;
            display: flex;
            align-items: center;
            overflow: hidden;
            // margin: 18px 0 42px;
            .company-logos{
              overflow: hidden;
              img{
                width: 28px;
                height: 28px;
                border: 1px solid #fff;
                position: relative;
                margin-left: -10px;
                float: left;
                border-radius: 50%;
                object-fit: contain;
                &:first-child{
                  margin-left: 0;
                  z-index: 5;
                }
                &:nth-child(2){
                  z-index: 4;
                }
              }
            }
            .introduction-text{
              font-size: 14px;
              color: #606060;
              margin-left: 10px;
            }

          }
          .right_info {
            position: relative;
            margin-top: 24px;
            .info_title {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 100%;
                height: 80px;
                .indo_name {
                  line-height: 20px;
                }
                .info_img {
                  margin-right: 24px;
                  display: flex;
                  width: 80px;
                  height: 80px;
                  border-radius: 6px;
                  border: 1px solid #F4F5F8;
                  img {
                    width: 100%;
                    height: 100%;
                    border-radius: 6px;
                    object-fit: contain;
                  }
                }
              .info_name {
                height:14px;
                font-size:14px;
                font-weight:400;
                color:rgba(64,64,64,1);
                line-height:14px;
              }
            }
            .info_ {
              position: relative;
              margin-top: 24px;
              width:300px;
              height:15px;
              font-size:14px;
              font-weight:400;
              color:rgba(96,96,96,1);
              line-height:15px;
              p {
                position: absolute;
                top: 0;
                left: 30px;
              }
            }
            .info_detail {
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              -webkit-line-clamp: 5;
              margin-top: 24px;
              //width:px;
              height:160px;
              font-size:14px;
              font-weight:400;
              color:rgba(96,96,96,1);
              line-height:32px;
            }
            .info_detail_log {
              //  overflow: hidden;
              display: -webkit-box;
              text-overflow: ellipsis;
              margin-top: 24px;
              //width:px;
              //  height:160px;
              font-size:14px;
              font-weight:400;
              color:rgba(96,96,96,1);
              line-height:32px;
            }
            .control_des {
              display: flex;
              justify-content: center;
              align-items: center;
              position: absolute;
              left: 45%;
              text-align: center;
              color: #f64;
              cursor: pointer;
              font-size: 14px;

            }
          }
          .right_hotjob {
            margin-top: 44px;
            .hot_title {
              font-size:18px;
              font-weight:bold;
              color:#404040;
              line-height:18px;
            }
            .hot_job {
              margin-top: 6px;
              .job_item {
                  display: flex;
                  padding-top: 21px;
                  height: 61px;
                  border-bottom: 1px dotted #EDEDED;
                  .img {
                    margin-right: 8px;
                  }
                  &:last-child{
                    border-bottom: 0;
                  }
                  .item_name {
                    margin-bottom: 12px;
                    height:14px;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(64,64,64,1);
                    line-height:14px;
                  }
                  .item_time {
                    margin-bottom: 20px;
                    height:14px;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(156,156,156,1);
                  }
                  &:hover{
                  .item_name{
                    color: #ff6644;
                  }
                }
              }
            }
          }

          .plugin{
            height: 300px;
            background: #F9F9F9;
            border-radius: 6px;
            margin-bottom: 48px;
            display: block;
            text-align: center;
            &-title{
              padding-top: 26px;
              line-height: 18px;
              margin-bottom: 10px;
            }
            &-desc{
              line-height: 16px;
            }
            img{
              display: block;
              width: 185px;
              margin: 0 auto 4px;
            }
            &:hover{
              .plugin-title{
                color: #ff6644;
              }
            }
          }
       }
     }
   }
 }
 .download-app{
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9;
    .content{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      width: 340px;
      border-radius: 10px;
      padding: 42px 0 36px;
      text-align: center;
      .title{
        font-size: 24px;
        color: #404040;
      }
      .text{
        font-size: 14px;
        color: #9c9c9c;
        margin: 12px 0 22px;
      }
      img{
        width: 176px;
        height: 176px;
        margin: 0 auto;
      }
    }
 }

.internal_recommend {
  height: 100%;
  position: relative;
  color: #797B7E;
  &:hover {
    color: #fff;
    .code {
      display: flex;
    }
  }
  .code {
    z-index: 99;
    display: none;
    width: 334px;
    height: 134px;
    background: #fff;
    position: absolute;
    // top: -10px;
    // left: -63%;
    top: -8px;
    left: -182px;
    transform: translateX(-50%);
    color: #404040;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(128, 128, 128, 0.16);
    align-items: center;
    .sanjiao {
      position: absolute;
      right: -15px;
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-left: 15px solid #ffffff;
      border-bottom: 10px solid transparent;
    }
    .title {
      margin-left: 20px;
      div:nth-child(1) {
        width: 160px;
        height: 18px;
        font-size: 16px;
        font-weight: 800;
        color: #404040;
        line-height: 18px;
        margin-bottom: 9px;
      }
      div:nth-child(2) {
        width: 159px;
        height: 18px;
        font-size: 12px;
        font-weight: 400;
        color: #606060;
        line-height: 18px;
      }
    }
    img {
      width: 100px;
      height: 100px;
      margin-left: 17px;
    }
  }
}
 .layer-box{
   position: fixed;
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   z-index: 99;
   background: rgba(0,0,0,0.39);
   display: flex;
   justify-content: center;
   align-items: center;
   .content-box{
     width: 340px;
     height: 335px;
     background: #FFFFFF;
     box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.13);
     border-radius: 10px;
     box-sizing: border-box;
     padding-top: 38px;
     display: flex;
     flex-direction: column;
     align-items: center;
     .content-box-title{
       font-size: 24px;
       font-weight: 500;
       color: #303030;
       line-height: 33px;
       text-align: center;
       margin-bottom: 12px;
     }
     .content-box-subtitle{
       font-size: 14px;
       font-weight: 400;
       color: #9C9C9C;
       line-height: 22px;
       text-align: center;
       margin-bottom: 18px;
     }
     .content-image{
       width: 176px;
       height: 176px;
     }
   }
 }
</style>
